import React from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import { BASEURL,PRIMARYCOLOR,SECONDARYCOLOR,logoURL,COMPANY } from '../../Constants';


function ForgotPasswordModal({ openModal, handleModalClose, setEmail, handleForgotPassword })
{

	return (
      <Modal open={openModal} onClose={handleModalClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2">
            Forgot Password
          </Typography>
          <TextField
            fullWidth
            label="Email"
            variant="standard"
            sx={{ mt: 2 }}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: PRIMARYCOLOR }}
            onClick={handleForgotPassword}
          >
            Send Reset Link
          </Button>
        </Box>
      </Modal>

		)
}

export default ForgotPasswordModal;
